import { Grid, styled, Typography } from '@mui/material';
import { HeaderProps } from './header.types';

export const Header = ({ subheaderText, titleText, labelGroups }: HeaderProps) => {
  return (
    <StyledWrapperGrid>
      <Grid mb={6} container>
        <Grid item xs={12} sx={{ marginBottom: subheaderText && 1 }}>
          <Typography variant="subtitle1" color="secondary" noWrap>
            {subheaderText ?? ''}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h1" noWrap>
            {titleText}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        {labelGroups
          ? labelGroups.map(({ title, description }, index) => {
              return (
                <Grid item xs={2} key={index}>
                  <Typography variant="subtitle2" color="secondary" noWrap>
                    {title}
                  </Typography>
                  <Typography variant="body1" noWrap>
                    {description}
                  </Typography>
                </Grid>
              );
            })
          : null}
      </Grid>
    </StyledWrapperGrid>
  );
};

const StyledWrapperGrid = styled(Grid)(({ theme }) => ({
  paddingBottom: theme.spacing(6),
  paddingTop: theme.spacing(8),
  width: '100%',
}));
